import { render, staticRenderFns } from "./documentmaster.vue?vue&type=template&id=2a820c08&scoped=true"
import script from "./documentmaster.vue?vue&type=script&lang=js"
export * from "./documentmaster.vue?vue&type=script&lang=js"
import style0 from "./documentmaster.vue?vue&type=style&index=0&id=2a820c08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a820c08",
  null
  
)

export default component.exports